var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-history" },
    [
      _c("div", { staticClass: "search-history__head" }, [
        _c("span", { staticClass: "search-history__name" }, [
          _vm._v("История"),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "search-history__clear",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.onClickClear.apply(null, arguments)
              },
            },
          },
          [_vm._v("\n      Очистить\n    ")]
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.lastThreeItems, function (item, ind) {
        return _c("search-history-item", {
          key: "item-history-" + ind,
          attrs: { name: item.value },
          on: { setValue: _vm.onClickItem, deleteValue: _vm.onClickDeleteItem },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }